import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { doc, setDoc, collection, getDocs, updateDoc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

export const createUnavailability = createAsyncThunk(
  'unavailabilities/createUnavailability',
  async ({ uid, data }) => {
    const unavailabilityRef = doc(collection(db, 'users', uid, 'unavailabilities'));
    await setDoc(unavailabilityRef, data);
    return { id: unavailabilityRef.id, ...data };
  }
);

export const manageUnavailability = createAsyncThunk(
  'unavailabilities/manageUnavailability',
  async ({ uid, data }) => {
    // Implement your logic to manage unavailability
    // This might involve reading from or writing to Firestore
  }
);

export const fetchUnavailabilities = createAsyncThunk(
  'unavailabilities/fetchUnavailabilities',
  async (uid) => {
    const snap = await getDocs(collection(db, 'users', uid, 'unavailabilities'));
    const unavailabilities = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    return unavailabilities;
  }
);

export const deleteUnavailability = createAsyncThunk(
  'unavailabilities/deleteUnavailability',
  async ({ uid, unavailabilityId }, { rejectWithValue }) => {
    try {
      const unavailabilityRef = doc(db, 'users', uid, 'unavailabilities', unavailabilityId);
      await deleteDoc(unavailabilityRef);
      return unavailabilityId;
    } catch (error) {
      console.error('Error deleting unavailability:', error);
      return rejectWithValue(error);
    }
  }
);

const unavailabilityInitialState = {
  unavailabilities: [],
  loading: false,
  error: null
};

export const unavailabilitySlice = createSlice({
  name: 'unavailabilities',
  initialState: unavailabilityInitialState,
  reducers: {
    resetUnavailabilities(state) {
      state.unavailabilities = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUnavailability.fulfilled, (state, action) => {
        state.unavailabilities.push(action.payload);
      })
      // Handle manageUnavailability (assumes it returns updated unavailabilities)
      .addCase(manageUnavailability.fulfilled, (state, action) => {
        state.unavailabilities = action.payload.updatedUnavailabilities;
      })
      .addCase(fetchUnavailabilities.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnavailabilities.fulfilled, (state, action) => {
        state.unavailabilities = Object.values(action.payload);
        state.loading = false;
      })
      .addCase(fetchUnavailabilities.rejected, (state) => {
        state.loading = false;
      })
      // Handle deleteUnavailabilityTimeSlots
      .addCase(deleteUnavailability.fulfilled, (state, action) => {
        state.unavailabilities = state.unavailabilities.filter(
          (unavailability) => unavailability.id !== action.payload
        );
      });
  }
});

export const { resetUnavailabilities } = unavailabilitySlice.actions;
export default unavailabilitySlice.reducer;
